import { Helmet } from "react-helmet";
import Banner from "../components/Banner";
import Section1 from "./Sections/Section1";
import Section2 from "./Sections/Section2";
import Section3 from "./Sections/Section3";
import Section4 from "./Sections/Section4";
import Section5 from "./Sections/Section5";
import Section6 from "./Sections/Section6";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>
          Buy Servers, PCs & Networking Equipment Online | TechMatter UK
        </title>
        <meta
          name="description"
          content="TechMatter UK offers high-quality servers, PCs, laptops, and networking hardware for businesses and home users across the UK and Europe. Shop top IT products online today."
        />
        <link rel="canonical" href="https://techmatter.co.uk/" />
      </Helmet>
      <Banner />
      <Section1 />
      <Section2 />
      <Section6 />
      <Section4 />
      <Section3 />
      <Section5 />
    </>
  );
}
